var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5003 9H3.41872M3.24634 9.7972L2.24158 12.7986C1.69128 14.4424 1.41613 15.2643 1.61359 15.7704C1.78506 16.21 2.15335 16.5432 2.6078 16.6701C3.13111 16.8161 3.92151 16.4604 5.50231 15.7491L15.6367 11.1886C17.1797 10.4942 17.9512 10.1471 18.1896 9.6648C18.3968 9.2458 18.3968 8.7541 18.1896 8.3351C17.9512 7.8529 17.1797 7.5057 15.6367 6.81135L5.48483 2.24303C3.90879 1.53382 3.12078 1.17921 2.59799 1.32468C2.14397 1.45101 1.77572 1.78336 1.60365 2.22209C1.40551 2.72728 1.67772 3.54741 2.22215 5.18767L3.24829 8.2793C3.34179 8.561 3.38855 8.7019 3.407 8.8459C3.42338 8.9738 3.42321 9.1032 3.40651 9.231C3.38768 9.375 3.34057 9.5157 3.24634 9.7972Z",
    stroke: "#7B4CFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.ffa138014d09355daecc00225a03bc76.svg";
export { ForwardRef as ReactComponent };